module.exports = __webpack_public_path__ + "static/media/2.5247999f.svg";